import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import CloseIcon from "assets/icons/close.svg?react";
import { useOnClickOutside } from "usehooks-ts";
import { useTranslation } from "react-i18next";

const SelectChannel: FC<Props> = ({
  onChoose,
  onClose,
  selectedStatus,
  initOpen = false,
}) => {
  const { t } = useTranslation();
  const channels = [
    { value: 12, text: t("packages.courtDelivery") },
    { value: 10, text: t("packages.otherCourtDocs") },
    { value: 24, text: t("packages.paper") },
    { value: 520, text: t("packages.confidential") },
    { value: 9, text: t("packages.notaPackages") },
    { value: 136, text: "E-mail" },
  ];
  const channel = channels.find((c) => c.value === selectedStatus);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!initOpen) return;
    setActive(true);
  }, [initOpen]);

  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (active) {
      setActive(false);
    }

    if (onClose && (selectedStatus === null || selectedStatus === -1)) {
      onClose();
    }
  });

  return (
    <div ref={outsideRef} className={styles.wrapper}>
      <div onClick={() => setActive(!active)} className={styles.card}>
        {channel ? (
          <div className={styles.text}>{channel.text}</div>
        ) : (
          <div className={styles.text}>{t("packages.communicationChannel")}</div>
        )}
        {selectedStatus && (
          <CloseIcon
            onClick={() => {
              onChoose(null);
              onClose?.();
            }}
          />
        )}
        {!onClose && (
          <FontAwesomeIcon icon={active ? faCaretUp : faCaretDown} />
        )}
      </div>

      {active && (
        <div className={styles.dropdown}>
          <div className={styles.list}>
            {channels?.map((status) => (
              <div
                onClick={() => {
                  setActive(false);
                  onChoose(status.value);
                }}
                key={status.value}
                className={styles.box}
              >
                {status.text}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectChannel;
